import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Componente para proteger rutas basadas en roles
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.allowedRoles - Array de roles permitidos para acceder a la ruta
 * @param {string} props.redirectTo - Ruta a la que redirigir si no tiene permisos
 */
const RoleBasedRoute = ({ allowedRoles, redirectTo = '/dashboard' }) => {
  const { hasRole } = useAuth();
  
  // Verificar si el usuario tiene al menos uno de los roles permitidos
  const hasPermission = allowedRoles.some(role => hasRole(role));
  
  // Si no tiene permiso, redirigir
  if (!hasPermission) {
    return <Navigate to={redirectTo} replace />;
  }
  
  // Si tiene permiso, renderizar el contenido
  return <Outlet />;
};

export default RoleBasedRoute; 